import {documentationPages} from "./documentation/pages";
import './App.css';
import Header from "./pages/Header";
import "./css/style.css";
import {Route, Routes} from "react-router";
import Home from "./pages/Home";
import {BrowserRouter} from "react-router-dom";
import SPTK_screenshots from "./pages/SPTK_screenshots";
import SPTK_themes from "./pages/SPTK_themes";
import SPTK_documentation from "./pages/SPTK_documentation";
import Footer from "./pages/Footer";
import Support from "./pages/Support";
import XMQ_about from "./pages/XMQ_about";
import XMQ_tests_connections from "./pages/XMQ_tests_connections";
import XMQ_tests_environment from "./pages/XMQ_tests_environment";
import XMQ_tests_fanin from "./pages/XMQ_tests_fanin";
import XMQ_tests_fanout from "./pages/XMQ_tests_fanout";
import XMQ_tests_p2p from "./pages/XMQ_tests_p2p";
import XMQ_tests_persistence from "./pages/XMQ_tests_persistence";
import XMQ_tests_encryption from "./pages/XMQ_tests_encryption";
import XMQ_tests_cluster from "./pages/XMQ_tests_cluster";
import XMQ_tests_chaos from "./pages/XMQ_tests_chaos";
import XMQ_mqtt_test_suite from "./pages/XMQ_mqtt_test_suite";
import XMQ_configuration from "./pages/XMQ_configuration";
import XMQ_persistence from "./pages/XMQ_persistence";
import XMQ_documentation from "./pages/XMQ_documentation";
import XMQ_doc_install from "./pages/XMQ_doc_install";
import XMQ_doc_setup from "./pages/XMQ_doc_setup";
import XMQ_doc_testing from "./pages/XMQ_doc_testing";
import XMQ_doc_permissions from "./pages/XMQ_doc_permissions";
import XMQ_doc_mosquitto_import from "./pages/XMQ_doc_mosquitto_import";
import XMQ_doc_data_integration from "./pages/XMQ_doc_data_integration";
import XMQ_doc_cluster from "./pages/XMQ_doc_cluster";
import XMQ_doc_load_balancer from "./pages/XMQ_doc_load_balancer";
import XMQ_doc_sizing from "./pages/XMQ_doc_sizing";
import Downloads from "./pages/Downloads";
import SPTK_about from "./pages/SPTK_about";
import AdminChangePassword from "./pages/AdminChangePassword";
import AdminAddNews from "./pages/AdminAddNews";
import Accordion from "./components/Accordion";
import {Component} from "react";
import ControlAPI from "./ControlAPI";
import LocalAuth from "./LocalAuth";

class App extends Component
{
    state = {
        counter: 0,
        loggedIn: LocalAuth.isLoggedIn
    }

    componentDidMount()
    {
        LocalAuth.onChanged = (isLoggedIn) => this.setState({loggedIn: isLoggedIn});
        this.getCounter(window.location.pathname).then(counter => {
            this.setState({counter: counter});
        });
    }

    async getCounter(activePage)
    {
        switch (activePage) {
            case "/":
            case "/home":
                activePage = "/index";
                break;
            default:
                break;
        }
        let sptkCounterName = "alexeyp" + activePage + ".php";
        const result = await ControlAPI.getRequest("counter.php", {countername: sptkCounterName});
        return result ? result.visitors : 0;
    }

    render()
    {
        let accordionMenu = [
            {
                title: "XMQ", items: [
                    {title: "Home", link: "/"},
                    {title: "About", link: "/xmq_about"},
                    {title: "Tests", items: [
                        {title: "Test Environment", link: "/xmq_tests_environment"},
                        {title: "Connections", link: "/xmq_tests_connections"},
                        {title: "Fan-in", link: "/xmq_tests_fanin"},
                        {title: "Fan-out", link: "/xmq_tests_fanout"},
                        {title: "Point-to-point", link: "/xmq_tests_p2p"},
                        {title: "Persistence", link: "/xmq_tests_persistence"},
                        {title: "Encryption", link: "/xmq_tests_encryption"},
                        {title: "Cluster", link: "/xmq_tests_cluster"},
                        {title: "Survivability", link: "/xmq_tests_chaos"},
                        {title: "MQTT Test Suite", link: "/xmq_mqtt_test_suite"},
                    ]},
                    {title: "Configuration", items: [
                        {title: "General", link: "/xmq_configuration"},
                        {title: "Persistence", link: "/xmq_persistence"},
                    ]},
                    {title: "Documentation", items: documentationPages.map(page => ({
                        title: page.label, link: page.path
                    }))},
                ]
            },
            {
                title: "SPTK", items: [
                    {title: "About", link: "/sptk_about"},
                    {title: "Screenshots", link: "/sptk_screenshots"},
                    {title: "Themes", link: "/sptk_themes"},
                    {title: "Documentation", link: "/sptk_documentation"},
                ]
            },
            {
                title: "Downloads", items: [
                    {title: "Files", link: "/downloads"},
                ]
            },
            {
                title: "Support", items: [
                    {title: "Prices", link: "/support"},
                ]
            },
        ];
        if (this.state.loggedIn) {
            accordionMenu.push({
                title: "Administration", items: [
                    {title: "Change Password", link: "/admin_change_password"},
                    {title: "Add News", link: "/admin_add_news"},
                ]
            });
        }
        return (
            <div className="App" style={{height: "100%", background: "#ddd"}}>
                {/* A column as tall as the window at least: the table takes what the header and the
                    footer leave, so the footer ends the window on a short page and follows the
                    content on a long one, whatever the window and its fonts. */}
                <div className='content' style={{display: "flex", flexDirection: "column", minHeight: "100vh", paddingBottom: 32}}>
                    <Header/>
                    <BrowserRouter>
                        {/* Sized in CSS units rather than from window.outerHeight: the
                            pre-rendered markup must not depend on the window it was
                            rendered in, or hydration would find a different height. */}
                        <table style={{width: "100%", flex: "1 0 auto"}}>
                            <tbody>
                            <tr style={{height: "1.5em"}}>
                                <td></td>
                                <td align="right" style={{width: "100%"}}>
                                    There were {this.state.counter} unique visitors to this page
                                </td>
                            </tr>
                            <tr>
                                <td style={{
                                    verticalAlign: "top",
                                    width: 200,
                                    backgroundColor: "#ddd",
                                    paddingRight: 16
                                }}>
                                    <div style={{height: "1em"}}></div>
                                    <Accordion menu={accordionMenu} onChange={async (page) => {
                                        let counter = await this.getCounter(page);
                                        this.setState({counter: counter});
                                    }}/>
                                </td>
                                <td style={{verticalAlign: "top"}}>
                                    <Routes>
                                        <Route path="/" Component={Home}/>
                                        <Route path="/support" Component={Support}/>
                                        <Route path="/xmq_about" Component={XMQ_about}/>
                                        <Route path="/xmq_tests_environment" Component={XMQ_tests_environment}/>
                                        <Route path="/xmq_tests_connections" Component={XMQ_tests_connections}/>
                                        <Route path="/xmq_tests_fanin" Component={XMQ_tests_fanin}/>
                                        <Route path="/xmq_tests_fanout" Component={XMQ_tests_fanout}/>
                                        <Route path="/xmq_tests_p2p" Component={XMQ_tests_p2p}/>
                                        <Route path="/xmq_tests_persistence" Component={XMQ_tests_persistence}/>
                                        <Route path="/xmq_tests_encryption" Component={XMQ_tests_encryption}/>
                                        <Route path="/xmq_tests_cluster" Component={XMQ_tests_cluster}/>
                                        <Route path="/xmq_tests_chaos" Component={XMQ_tests_chaos}/>
                                        <Route path="/xmq_mqtt_test_suite" Component={XMQ_mqtt_test_suite}/>
                                        <Route path="/xmq_configuration" Component={XMQ_configuration}/>
                                        <Route path="/xmq_persistence" Component={XMQ_persistence}/>
                                        <Route path="/xmq_documentation" Component={XMQ_documentation}/>
                                        <Route path="/xmq_doc_install" Component={XMQ_doc_install}/>
                                        <Route path="/xmq_doc_setup" Component={XMQ_doc_setup}/>
                                        <Route path="/xmq_doc_testing" Component={XMQ_doc_testing}/>
                                        <Route path="/xmq_doc_permissions" Component={XMQ_doc_permissions}/>
                                        <Route path="/xmq_doc_mosquitto_import" Component={XMQ_doc_mosquitto_import}/>
                                        <Route path="/xmq_doc_data_integration" Component={XMQ_doc_data_integration}/>
                                        <Route path="/xmq_doc_cluster" Component={XMQ_doc_cluster}/>
                                        <Route path="/xmq_doc_sizing" Component={XMQ_doc_sizing}/>
                                        <Route path="/xmq_doc_load_balancer" Component={XMQ_doc_load_balancer}/>
                                        <Route path="/sptk_about" Component={SPTK_about}/>
                                        <Route path="/sptk_screenshots" Component={SPTK_screenshots}/>
                                        <Route path="/sptk_themes" Component={SPTK_themes}/>
                                        <Route path="/sptk_documentation" Component={SPTK_documentation}/>
                                        <Route path="/downloads" Component={Downloads}/>
                                        <Route path="/admin_change_password" Component={AdminChangePassword}/>
                                        <Route path="/admin_add_news" Component={AdminAddNews}/>
                                    </Routes>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <Footer/>
                    </BrowserRouter>
                </div>
            </div>);
    }
}

export default App;
